import React from 'react';
import '../styling/componentStyles.css'
import TextField from '@material-ui/core/TextField';


interface TextBoxProps{
    label: string;
    className: String;
    state:String;
    placeholder: string;
    handleToUpdate: Function;
    defaultValue?: string;
    disabled?:boolean;
}

export const TextBox: React.FC<TextBoxProps> = (props: TextBoxProps) =>{
    const{
        label, state, placeholder, handleToUpdate, defaultValue, disabled, className
    } = props;

        return (
            <div className='textbox'>
                <div className='textboxLabel'>
                    <label>{label}</label>
                </div>
                {/* <br/> */}
                {disabled &&
                    <TextField
                        id={label}
                        className={className === "textBox custom_input" ? 'textField custom_input' : 'textField'}
                        placeholder={placeholder}
                        label={placeholder}
                        variant="filled"
                        disabled
                        value={defaultValue}
                        onChange={(event) => {
                            handleToUpdate(state, event.target.value)
                        }}
                    />
                }
                { !disabled &&
                    <TextField
                        id={className === "re_enter_account_number" ? "re_enter_account_number" : label}
                        className={className === "textBox custom_input" ? 'textField custom_input' : 'textField'}
                        placeholder={placeholder}
                        label={placeholder}
                        variant="filled"
                        value={defaultValue}
                        onChange={(event) => {
                            handleToUpdate(state, event.target.value)
                        }}
                        /> 
                }               
            </div>
        )
    }


export default TextBox